/* eslint-disable indent */
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';
import { SeoHead } from '../containers/components';
import { Page } from '../containers/pages/page';
import { getPrefooterTypeData } from '../services/bestCitiesByType';
import {
  getAllSectionFromPageCache,
  getFooterCache,
  getNavBarCache,
} from '../services/cache';
import { StrapiApi } from '../services/strapiApi';
import {
  FooterSectionType,
  NavigationBarType,
  PageBaseProps,
  PageSectionType,
  PageSeo,
  PreFootersType,
  SectionsType,
} from '../types';

export interface EntreprisesProps {
  pageSections: PageSectionType<SectionsType>[];
  navBarSection: PageSectionType<NavigationBarType>;
  footerSection: PageSectionType<FooterSectionType>;
  hasBooker: boolean;
  seo: PageSeo;
  preFooterType: PreFootersType;
}

export default function NextPage(props: EntreprisesProps): JSX.Element {
  return (
    <>
      <SeoHead title={props.seo?.title} description={props.seo?.description} />
      <Page
        pageSections={props.pageSections}
        navBarSection={props.navBarSection}
        footerSection={props.footerSection}
        hasBooker={props.hasBooker}
        preFooterType={props.preFooterType}
      />
    </>
  );
}

export async function getStaticProps({
  locale,
}: {
  locale: string;
}): Promise<PageBaseProps> {
  const navBarSection = await getNavBarCache();
  const footer = await getFooterCache();
  const page = await StrapiApi.single_types.rseTravailPage('fr');
  const sections = await getAllSectionFromPageCache(page);
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      pageSections: sections,
      navBarSection: navBarSection,
      footerSection: footer,
      seo: page.seo,
      hasBooker: page.booker,
      preFooterType: getPrefooterTypeData(),
    },
    revalidate: Number(process.env.NEXT_PUBLIC_REVALIDATE_TIME),
  };
}
